// extracted by mini-css-extract-plugin
module.exports = {"component":"TFMPoweredBy_component__ypdPD","link":"TFMPoweredBy_link__2zqtP"};